export const CrossSellFieldKeys = {
  NUMBER_CO_INSURED: 'numberCoInsured',
  START_DATE: 'startDate',
  INTENT: 'intent',
  MILEAGE: 'mileage',
} as const
